import { Box, Tooltip } from "@mui/material";
import React, { useState } from "react";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import PropTypes from "prop-types";
import PrimaryButton from "src/Components/shared/shared/PrimaryButton";

function AddSection({ toggleOpen }) {
  AddSection.propTypes = {
    toggleOpen: PropTypes.func.isRequired,
  };

  const ContainerStyle = {
    display: "flex",
    justifyContent: "space-between",
  };

  return (
    <>
      <Box sx={ContainerStyle}>
        <Tooltip
          title="Click to add charts to your workbook. Charts you close will appear here."
          arrow
          placement="bottom"
        >
          <span>
            <PrimaryButton 
              startIcon={<AddOutlinedIcon />} 
              onClick={toggleOpen}
              sx={{
                height: {
                  xs: "32px",
                  sm: "36px",
                  md: "40px",
                },
                minWidth: {
                  xs: "120px",
                  sm: "140px",
                  md: "160px",
                },
                fontSize: {
                  xs: "11px",
                  sm: "12px",
                  md: "14px",
                },
                padding: {
                  xs: "4px 8px",
                  sm: "6px 12px",
                  md: "6px 16px",
                },
                "& .MuiButton-startIcon": {
                  marginRight: {
                    xs: "4px",
                    sm: "6px",
                    md: "8px",
                  },
                  "& > *:nth-of-type(1)": {
                    fontSize: {
                      xs: "16px",
                      sm: "18px",
                      md: "20px",
                    },
                  },
                },
                transition: "box-shadow 0.2s ease",
                "&:hover": {
                  backgroundColor: "primary.main",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                },
              }}
            >
              Add New Chart
            </PrimaryButton>
          </span>
        </Tooltip>
      </Box>
    </>
  );
}

export default AddSection;
